import React from 'react';
import config from './config.js'


const PopupVisualisation = ({ pointsurvolle }) => {

    const getIcone = (thematique) => {
        var l = config.contenu.filter(a => a.thematique === thematique);
        if (l.length > 0) {
            return l[0];
        }
        else
            return null;

    }

    if (pointsurvolle) {

        let images = require.context('./assets/pictos', true);
        let theme = getIcone(pointsurvolle.thematique)
        let itemImg = images(`./${theme.picto}`);
        
        return <div className={"popup"}>
            <div className="popup_vis_titre1">
                {pointsurvolle.photo && pointsurvolle.photo !== "" ?
                    <img className={"popup_image"} alt={pointsurvolle.titre} src={process.env.PUBLIC_URL + "/images/" + pointsurvolle.photo} />
                    : null
                }
                <div>
                    <img src={itemImg} className="popup_picto" alt={pointsurvolle.nom} title={pointsurvolle.nom} />
                    <div className="popup_titre">{pointsurvolle.nom}</div>
                </div>
            </div>
            <div className="popup_separation"></div>
            <div className="popup_description">
                {pointsurvolle.texte}
            </div>
            {pointsurvolle.nb_salle && pointsurvolle.nb_salle !== "" && pointsurvolle.nb_fauteuil && pointsurvolle.nb_fauteuil !== "" ?
                <>
                    <div className="popup_separation"></div>
                    <div className="popup-adresse">
                        {pointsurvolle.nb_salle && pointsurvolle.nb_salle !== "" ? <div>Nombre de salles: <b>{pointsurvolle.nb_salle}</b></div> : null}
                        {pointsurvolle.nb_fauteuil && pointsurvolle.nb_fauteuil !== "" ? <div>Nombre de fauteuils: <b>{pointsurvolle.nb_fauteuil}</b></div> : null}
                    </div>
                </>
                : null
            }
            <div className="popup_separation"></div>
            <div className="popup-adresse">
                <div><b>Adresse:</b> {pointsurvolle.adresse}, {pointsurvolle.cp}, {pointsurvolle.ville}</div>
                {
                    pointsurvolle.tel && pointsurvolle.tel !== "" ? <div><b>Téléphone : </b>{pointsurvolle.tel}</div> : null
                }
                {
                    pointsurvolle.mail && pointsurvolle.mail !== "" ? <div><b>Email : </b> <a href={`mailto:${pointsurvolle.mail}`}>{pointsurvolle.mail}</a></div> : null
                }

                {
                    pointsurvolle.url && pointsurvolle.url !== "" ? <div><b>Site web:</b> <a target="_blank" rel="noreferrer" href={pointsurvolle.url}>{pointsurvolle.url}</a></div> : null
                }
            </div>
        </div>;
    }
    else
        return null
}

export default PopupVisualisation;